import { render, staticRenderFns } from "./v-contextual-option.vue?vue&type=template&id=40742edd&slot-scope=slotProps"
import script from "./v-contextual-option.vue?vue&type=script&lang=js"
export * from "./v-contextual-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports